<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      Copy Checklist
      <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <form [formGroup]="projectForm" autocomplete="off">
      <div class="row m-0 eip-pt-20">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <edms-autocomplete [data]="projectList" [form]="projectForm" controlName="Fromproject" textField="projCodeDesc" label="From Project" error="Select project" (optionSelected)="FromProjectChange($event)" [value]="selectedFromProject">
              </edms-autocomplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <edms-autocomplete [data]="FrombusinessGroups" [form]="projectForm" controlName="FrombusinessGroup" textField="group_Name" label="From Business Group" (optionSelected)="FromBUChange($event)" error="Please select from business group">
              </edms-autocomplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <edms-autocomplete [data]="disciplineList" [form]="projectForm" controlName="FromDiscipline" textField="dedDescription" label="From Discipline" (optionSelected)="FromDisplineChange($event)" error="Please select from Discipline group">
              </edms-autocomplete>
          </div>
      </div>
      <div class="row m-0 eip-pt-20">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <edms-autocomplete [data]="projectList" [form]="projectForm" controlName="Toproject" textField="projCodeDesc" label="To Project" error="Select project" (optionSelected)="ToProjectchange($event)">
              </edms-autocomplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <edms-autocomplete [data]="TobusinessGroups" [form]="projectForm" controlName="TobusinessGroup" textField="group_Name" label="To Business Group" (optionSelected)="ToBuchange($event)">
              </edms-autocomplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <edms-autocomplete [data]="TodisciplineList" [form]="projectForm" controlName="ToDiscipline" textField="dedDescription" label="To Discipline" (optionSelected)="ToDisiplinechange($event)">
              </edms-autocomplete>
          </div>
      </div>
      <kendo-grid [kendoGridBinding]="checkList" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="enablechkLstFilter" [pageSize]="15" [pageable]="true" [selectable]="true" (dataStateChange)="dataStateChange($event)" (selectionChange)="onSelectionChange($event)">
          <ng-template kendoPagerTemplate>
              <div class="k-pager-left">
                  <kendo-pager-info></kendo-pager-info>
              </div>
              <div class="k-pager-right">
                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                  <kendo-pager-input></kendo-pager-input>
                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
              </div>
          </ng-template>
          <ng-template kendoGridToolbarTemplate>
              <div class="k-grid-toolbar-content d-flex">
                  <div class="flex-grow-1 title-container">
                      <p class="title"></p>
                  </div>
                  <div class="flex-grow-1 mat-panel-headerbar"></div>
                  <div class="divider-container d-none d-md-block" id="imgDivider">
                      <span></span>
                  </div>
                  <div class="pagination-container">
                      <p id="lblShowDetails">Show</p>
                      <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                      </kendo-pager-page-sizes>
                      <span>Items</span>
                  </div>
                  <div class="divider-container d-none d-md-block" id="imgDivider">
                      <span></span>
                  </div>
                  <div class="icons-container">
                      <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                      <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                          <div class="icon-wrap" (click)="clearSelectedFilter()">
                              <i class="fa fa-reset" title="Clear Filter" aria-hidden="true"></i>
                              <span class="list-icon-name">Clear Filter</span>
                          </div>
                          <div class="icon-wrap" (click)="toggleFilter()">
                              <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                              <span class="list-icon-name">Filter</span>
                          </div>
                          <div class="icon-wrap">
                              <i class="fa fa-cog" title="Settings" aria-hidden="true"></i>
                              <span class="list-icon-name">Grid Settings</span>
                          </div>
                          <div class="icon-wrap" (click)="toggleChklstFullscreen()">
                              <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                              <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                          </div>
                      </div>
                  </div>
              </div>
          </ng-template>
          <kendo-grid-checkbox-column showSelectAll="true" width="40"></kendo-grid-checkbox-column>
          <kendo-grid-column title="Check List Name" field="clDescription">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="chklist-hover" eipTooltip="{{dataItem.clDescription}}" eipTooltipPosition="auto">{{dataItem.clDescription}}</span>
              </ng-template>
              <ng-template kendoGridEditTemplate let-column="column" let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <mat-form-field>
                      <input matInput type="text" formControlName="clDescription">
                  </mat-form-field>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Check List Short Name" field="clShortDescription" width=250>
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="chklist-hover" eipTooltip="{{dataItem.clShortDescription}}" eipTooltipPosition="auto">{{dataItem.clShortDescription}}</span>
              </ng-template>
          </kendo-grid-column>

          <!-- IC -->
          <kendo-grid-column title="IC" field="icDescription">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="chklist-hover" eipTooltip="{{dataItem.icDescription}}" eipTooltipPosition="auto">{{dataItem.icDescription}}</span>
              </ng-template>
          </kendo-grid-column>

          <!-- BU -->
          <kendo-grid-column title="BU" field="buDescription">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="chklist-hover" eipTooltip="{{dataItem.buDescription}}" eipTooltipPosition="auto">{{dataItem.buDescription}}</span>
              </ng-template>
          </kendo-grid-column>

          <!-- Project -->
          <kendo-grid-column title="Project" field="projectDescription">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="chklist-hover" eipTooltip="{{dataItem.projectDescription}}" eipTooltipPosition="auto">{{dataItem.projectDescription}}</span>
              </ng-template>
          </kendo-grid-column>

          <!-- Business group -->
          <kendo-grid-column title="Business Group" field="groupDescription">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="chklist-hover" eipTooltip="{{dataItem.groupDescription}}" eipTooltipPosition="auto">{{dataItem.groupDescription}}</span>
              </ng-template>
          </kendo-grid-column>

          <!-- Discipline -->
          <kendo-grid-column title="Discipline" field="disciplineDescription">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="chklist-hover" eipTooltip="{{dataItem.disciplineDescription}}" eipTooltipPosition="auto">{{dataItem.disciplineDescription}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Active Status">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <mat-slide-toggle [checked]="dataItem.isActive" color="primary" disabled>
                  </mat-slide-toggle>
              </ng-template>
          </kendo-grid-column>
      </kendo-grid>
  </form>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button (click)="savecopychecklist()" class="btn btn-primary" type="submit" id="btnEDMSave"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;{{actionButtonText}}</button>&nbsp;
      <button (click)="closeDialog()" class="btn btn-secondary" id="btnEDMCancel"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button>
  </div>
</div>